import CellRenderer from './CellRenderer';

export default CellRenderer;
